import React from "react";
import { useNavigate } from "react-router-dom";

import RecruiterProfile from "../components/scouting/RecruiterProfile";
import { useAuth } from "../context/AuthContext";
import { useNotifications } from "../components/layout/routing/AppShell";

const RecruiterProfileRoute = () => {
  const navigate = useNavigate();
  const { scoutData, activeSearchId } = useAuth();
  const { openNotifications } = useNotifications();

  return (
    <RecruiterProfile
      scoutData={scoutData}
      onNotificationsClick={openNotifications}
      onSearchClick={() =>
        navigate(
          activeSearchId
            ? `/scout/searches/${activeSearchId}`
            : "/scout/searches",
        )
      }
    />
  );
};

export default RecruiterProfileRoute;
